import React, { useContext, useEffect, useRef, useState, useTransition } from 'react'
import UserContext from 'contexts/UserContext'
import DrapeuTUN from '../assets/flagTND.svg'
import DrapeuSEN from '../assets/flegSEN.svg'
import DrapeuMAC from '../assets/flagMAC.svg'
import DrapeuALG from '../assets/flagALGR.svg'
import DrapeuNGA from '../assets/flagNigeriDestination.svg'
import DrapeuKEN from '../assets/flagkenyaDestination.svg'
import DrapeuPHL from '../assets/flagPhilippinesDestination.svg'
import DrapeuPKR from '../assets/drapeauRounded/flagPKR.svg'
import DrapeuABDT from '../assets/drapeauRounded/flagBDT.svg'
import DrapeuTRK from '../assets/drapeauRounded/flagTRK.svg'
import handlogohome from '../assets/handlogohome.svg'
import useClickOutside from '../hooks/useOnclickOutside'
import DropDown from 'assets/iconTsx/DropDown'
import { useTranslation } from 'react-i18next'
const Haut: React.FC = () => {
  const { user } = useContext(UserContext)
  const currentPath = location.pathname
  const destinationDefaultCountry = user?.user?.destinationDefaultCountry
  const listeDrapeu = [
    { pays: 'TUN', flag: DrapeuTUN },
    { pays: 'SEN', flag: DrapeuSEN },
    { pays: 'MAC', flag: DrapeuMAC },
    // {pays:'ALG', flag:DrapeuALG},
    { pays: 'PKR', flag: DrapeuPKR },
    { pays: 'TRY', flag: DrapeuTRK },
    { pays: 'BDT', flag: DrapeuABDT },
    { pays: 'NGA', flag: DrapeuNGA },
    { pays: 'KEN', flag: DrapeuKEN },
    { pays: 'PHL', flag: DrapeuPHL },
  ]
  const OrderListe = [
    ...listeDrapeu.filter((item) => destinationDefaultCountry === item.pays),
    ...listeDrapeu.filter((item) => destinationDefaultCountry !== item.pays),
  ]
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const RefFlag = useRef<HTMLDivElement>(null)
  const RefFlagScroll = useRef<(HTMLDivElement | null)[]>([])
  const { t } = useTranslation()

  const toggleSetting = () => setIsOpen(false)
  useClickOutside(toggleSetting, RefFlag)

  useEffect(() => {
    if (isOpen) {
      setCurrentIndex(0)
      setTimeout(() => {
        RefFlagScroll.current[0]?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }, 100)
    }
  }, [isOpen])
  const handleScrollDown = (direction: 'top' | 'bas') => {
    let nextIndex = currentIndex
    if (direction === 'bas' && currentIndex < OrderListe.length - 2) {
      nextIndex = currentIndex + 1
    }

    if (direction === 'top' && currentIndex > 0) {
      nextIndex = currentIndex - 1
    }

    setCurrentIndex(nextIndex)

    RefFlagScroll.current[nextIndex + 1]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  }
  return (
    <div className="flex justify-between items-center  h-[80px] lg:hidden relative">
      <div className="flex gap-5 w-full   items-center  lg:hidden   ">
        <div className="text-[24px] font-semibold ">{t("languages.greeting")} {user?.user?.personalInfo?.lastName}</div>
        <img src={handlogohome} className="w-8 h-8" />
      </div>
      <div className=" mr-[40px] font-semibold  text-[#5754E5]">
        {(currentPath == '/' || currentPath === '/settingProfile/0') && `${t('languages.code')}`}
      </div>

      {(currentPath == '/' || currentPath === '/settingProfile/0') && user?.user.destinationDefaultCountry && (
        <div ref={RefFlag} className=" relative w-[70px]">
          {!isOpen ? (
            <img
              onClick={() => {
                setIsOpen(!isOpen)
              }}
              className="m-2 cursor-pointer  w-[45px] h-autocursor-pointer border-2 border-[#FFF] rounded-full"
              src={OrderListe[0].flag}
              width={35}
              height={35}
              alt=""
            />
          ) : (
            <div className="flex absolute  -top-[35px] right-0 flex-col items-center gap-1">
              <DropDown
                onClick={() => handleScrollDown('top')}
                styleCssImage="cursor-pointer rotate-180  stroke-[#AEB6FB]"
              />

              <div className="bg-[#FFF] border-[#AEB6FB] border-2  rounded-[80px] overflow-y-auto max-h-[220px] scrollbar-hide p-2 gap-2 h-full flex flex-col items-center  shadow-[0px_0px_6px_rgba(66,46,174,0.4)]">
                {(RefFlagScroll.current = [])}
                {OrderListe.map((item, index) => (
                  <div
                    ref={(el) => (RefFlagScroll.current[index] = el)}
                    key={index}
                    className={`${item.pays === destinationDefaultCountry && ' border border-[#5754E5] rounded-full'}`}
                  >
                    <img
                      onClick={() => {
                        if (item.pays === destinationDefaultCountry) {
                          setIsOpen(false)
                        }
                      }}
                      className={`${item.pays !== destinationDefaultCountry ? 'opacity-50 cursor-default shadow-selct shadow-[#5754E5]' : 'cursor-pointer border-2 border-[#FFF] rounded-full'}  w-[45px] h-auto rounded-full `}
                      src={item.flag}
                      alt=""
                      width={35}
                      height={35}
                    />
                  </div>
                ))}
              </div>
              <DropDown onClick={() => handleScrollDown('bas')} styleCssImage="cursor-pointer stroke-[#AEB6FB]" />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
export default Haut
